import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class MenuIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          d='M0.024,10.000 L0.024,8.006 L11.999,8.006 L11.999,10.000 L0.024,10.000 ZM-0.007,3.986 L11.999,3.986 L11.999,5.994 L-0.007,5.994 L-0.007,3.986 ZM-0.013,-0.001 L11.993,-0.001 L11.993,2.007 L-0.013,2.007 L-0.013,-0.001 Z'/> ]
  getViewBox = () => '-1 0 14 10'
}
